<template>
  <div class="container">
    <div class="selectconditons">
      <a-row :gutter="24">
        <a-button type="primary" icon="plus" style="margin-left: 1%" @click="openAddModal()">添加一组信息</a-button>
      </a-row>
    </div>
    <div class="selectresulttable">
      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="false"
        :scroll="{ x: 1000 }"
        :loading="loading"
        bordered
      >
        <span slot="action" slot-scope="text, record">
          <!-- editIndustry -->
          <a-button type="link" @click="openAddModal(record)" size="small" style="margin-right: 3px">修改</a-button>
          <a-button type="link" style="color: #ff4d4f" @click="deleteIndustry(record)" size="small">删除</a-button>
        </span>
      </a-table>
      <div class="pageBar">
        <a-pagination
          style="margin-top: 1%; float: right"
          size="small"
          :current="pagination.current"
          :total="pagination.total"
          :show-total="(total, range) => `${range[0]}-${range[1]} 共 ${total} 条`"
          show-size-changer
          show-quick-jumper
          :showSizeChanger="true"
          :pageSize="pagination.pageSize"
          :pageSizeOptions="pagination.pageSizeOptions"
          @change="onChange"
          @showSizeChange="showSizeChange"
        />
      </div>
    </div>
    <ManagEsignatureModal
      ref="ManagEsignatureModal"
      @ok=";(pagination.current = 1), getTableDate()"
    ></ManagEsignatureModal>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import moment from 'moment'
import { deleteAction } from '@/api/manage'
import ManagEsignatureModal from './modules/ManagEsignatureModal.vue'
//表格字段名称
const columns = [
  {
    title: '签名',
    dataIndex: 'signatures',
    key: 'signatures',
  },

  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    align: 'center',
  },
  {
    title: '修改时间',
    dataIndex: 'updateTime',
    key: 'updateTime',
    align: 'center',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  components: { ManagEsignatureModal },
  data() {
    return {
      columns,
      data: [],
      //页码数据
      pagination: {
        current: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15', '20'],
        pageSize: 10,
      },
      //查询参数
      inputGroup: {
        platform: '',
        smsType: '',
        userid: '',
      },
      loading: false,
      url: {
        list: '/base/busCommonMessageSignatures/list',
      },
    }
  },
  mounted() {
    this.getTableDate()
  },
  methods: {
    openAddModal(record) {
      if (record && record.id) {
        this.$refs.ManagEsignatureModal.title = '修改签名'
      } else {
        this.$refs.ManagEsignatureModal.title = '新增签名'
      }
      this.$refs.ManagEsignatureModal.edit(record)
    },
    //删除账号信息二步确认
    deleteIndustry(industry) {
      this.$antdConfirm({
        title: '是否删除短信签名为' + industry.type + '的签名信息?',
        content: (h) => (
          <div style="color:red;">
            <a-icon type="info-circle" style="margin-right:10px" />
            删除操作不可恢复的哦
          </div>
        ),
        okText: '是',
        okType: 'danger',
        cancelText: '点错啦',
        onOk: () => {
          this.doDelete(industry.id)
        },
        onCancel: () => {
          this.$message.success('感谢您的仁慈！')
        },
      })
    },
    //删除信息账号
    doDelete(id) {
      deleteAction('/base/busCommonMessageSignatures/delete?id=' + id).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.getTableDate()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //页面换页重新获取表格数据
    onChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.getTableDate()
    },
    //页面容量修改时重新获取表格数据
    showSizeChange(current, size) {
      this.pagination.current = current
      this.pagination.pageSize = size
      this.getTableDate()
    },
    //获取表格数据
    getTableDate() {
      this.loading = true
      let parms = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        platform: this.inputGroup.platform,
        smsType: this.inputGroup.smsType,
        userid: this.inputGroup.userid,
      }
      getAction(this.url.list, parms).then((res) => {
        this.data = res.result.records
        this.pagination.current = res.result.current
        this.pagination.total = res.result.total
        this.loading = false
      })
    },
  },
}
</script>

<style scoped>
.container {
  background-color: #ffffff;
  height: 100%;
  width: 100%;
}
.selectconditons {
  padding-top: 1%;
  padding-left: 1%;
  background-color: #ffffff;
}
.selectresulttable {
  padding: 0.5%;
  background-color: #ffffff;
}
.pageBar {
  width: 100%;
  height: 3rem;
  background-color: #ffffff;
}
.titleLabel {
  float: right;
  padding-right: 10%;
}
.nullTips {
  color: red;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  margin: auto;
}
.rowStyle {
  height: 100%;
  margin-top: 15px;
}
.width-100 {
  width: 100%;
}
</style>
